import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { DETALLES } from '../../data/retiro';
export function Detalles() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'rgba(176,146,191,0.08)'
  }} data-id="element-33">
      <div className="mx-auto max-w-5xl" data-id="element-34">
        <SectionHeading eyebrow="Detalles Logísticos" title="Todo lo que necesitas saber" data-id="element-35" />

        <div className="mt-14 overflow-hidden rounded-3xl border bg-white/70" style={{
        borderColor: 'rgba(200,153,46,0.2)'
      }} data-id="element-36">
          {DETALLES.map((d, i) => <Reveal key={d.aspecto} data-id="element-37">
              <div className="flex flex-col gap-1 px-6 py-6 sm:flex-row sm:items-center sm:gap-8 sm:px-8" style={{
            borderTop: i === 0 ? 'none' : '1px solid rgba(42,36,32,0.08)'
          }} data-id="element-38">
                <div className="flex items-center gap-3 sm:w-64 sm:shrink-0" data-id="element-39">
                  <span className="text-2xl" data-id="element-40">{d.emoji}</span>
                  <span className="font-medium" style={{
                color: 'var(--ink)'
              }} data-id="element-41">
                    {d.aspecto}
                  </span>
                </div>
                <p className="text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.72)'
            }} data-id="element-42">
                  {d.detalle}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-43">
          <p className="mt-8 text-center text-sm leading-relaxed" style={{
          color: 'rgba(42,36,32,0.7)'
        }} data-id="element-44">
            ✨{' '}
            <strong style={{
            color: 'var(--darkgoldenrod)'
          }} data-id="element-45">
              Cupos limitados.
            </strong>{' '}
            Incluye transporte, sorpresas de magia pura y todo lo que tu
            bienestar merece. Tu transformación comienza con un <em data-id="element-46">SÍ</em>.
          </p>
        </Reveal>
      </div>
    </section>;
}